export const activityFeedTitle = "dCa";
export default {activityFeedTitle};